// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as CampaignModificationEntityMapper from "../entity-mapper/CampaignModificationEntityMapper.bs.js";
import * as CreateModificationErrorConverter from "./create-modification-error-handler/CreateModificationErrorConverter.bs.js";

var execute = CampaignModificationEntityMapper.execute;

var ModificationListResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var ModificationListResponseConverter = partial_arg(ModificationListResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$1(data) {
  return data;
}

var CreateModificationResponseConverterConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var CreateModificationResponseConverter = partial_arg$1(CreateModificationResponseConverterConfig, CreateModificationErrorConverter);

function execute$2(data) {
  return data;
}

var ReprioritizeModificationResponseConverterConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var ReprioritizeModificationResponseConverter = partial_arg$2(ReprioritizeModificationResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$3(data) {
  return data;
}

var EditModificationResponseConverterConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$Catalyst.ResponseConverter;

var EditModificationResponseConverter = partial_arg$3(EditModificationResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  ModificationListResponseConverterConfig ,
  ModificationListResponseConverter ,
  CreateModificationResponseConverterConfig ,
  CreateModificationResponseConverter ,
  ReprioritizeModificationResponseConverterConfig ,
  ReprioritizeModificationResponseConverter ,
  EditModificationResponseConverterConfig ,
  EditModificationResponseConverter ,
  
}
/* ModificationListResponseConverter Not a pure module */
